import { render } from "./FacebookAdPreview.vue?vue&type=template&id=24103e8e&scoped=true"
import script from "./FacebookAdPreview.vue?vue&type=script&lang=js"
export * from "./FacebookAdPreview.vue?vue&type=script&lang=js"

import "./FacebookAdPreview.vue?vue&type=style&index=0&id=24103e8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24103e8e"]])

export default __exports__